export enum AvailableFont {
  NexaRegular = "NexaRegularTSF",
  NexaHeavy = "NexaHeavyTSF",
  ObjectivRegular = "ObjectivMk1TSF",
  ObjectivHeavy = "ObjectivMk1HeavyTSF",
  DinRoundProRegular = "DinRoundProTSF",
  DinRoundProBlack = "DinRoundProBlackTSF",
  Baloo2 = "Baloo2TSF",
  Baloo2Heavy = "Baloo2HeavyTSF",
}
